import { Suspense } from "react";
import { LegacyNotFoundPage } from "../bridges/legacyPages";
import { InFrameNotFound } from "../access/components/NotForYou";
import { FrameSwitch } from "./FrameSwitch";
import { useFrameMode } from "./frameMode";

/** Is someone signed in on this browser? Same test the private routes use. */
const signedIn = (): boolean => {
  try { return !!localStorage.getItem("user"); } catch { return false; }
};

/**
 * Layout of the catch-all address (P6.1-6.3, walkthrough-public #16): a signed-in person gets "Page not found" INSIDE the app frame
 * (menu and top bar stay); a visitor gets the public "Page not found" page (public frame) as before.
 */
export const NotFoundLayout = ({ mapsReady, bootLoader }: { mapsReady: boolean; bootLoader: JSX.Element }): JSX.Element =>
  signedIn() ? <FrameSwitch mapsReady={mapsReady} bootLoader={bootLoader} /> : <Suspense fallback={null}><LegacyNotFoundPage /></Suspense>;

/** The body inside the frame: the new frame's own page; today's frame keeps today's 404 content. */
export const NotFoundInFrame = (): JSX.Element => {
  const mode = useFrameMode();
  return mode === "next" ? <div className="cy-next"><InFrameNotFound /></div> : <Suspense fallback={null}><LegacyNotFoundPage /></Suspense>;
};

